import axios from "axios";

const AdminBaseUrl = process.env.REACT_APP_AdminBaseUrl;
export const uploadImages = async (data) => {
    try {
        const response = await axios.post(`${AdminBaseUrl}/upload-images/`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return {
            status: true,
            data: response.data
        }

    } catch (error) {
        return {
            status: false,
            data: null,
            error: error?.
                message
        }
    }
};